export const ensureArray = <T>(listOrElement: T|T[]): T[] =>
  Array.isArray(listOrElement) ? listOrElement : [listOrElement];

/**
 * Convert comma/new line separated string to array
 */
export const getArrayFromString = (value: string = ''): string[] => {
  const strWithCommas = value.replaceAll(/\n+/gi, ',') || '';
  const codes = strWithCommas.split(',') || [];
  return codes.map(item => item.trim()).filter(item => item.length);
};

/**
 * Convert array to comma separated string
 */
export const getStringFromArray = (value?: (string | number)[]) => value?.join(', ') || '';

export const getUniqueArray = (arr: any[]) => [...new Set(arr)];
